<cdk-accordion class="accordion menu-dashboard">
  @if (pages$ | async; as pages) {
    @for (page of pages; track page; let pageIndex = $index) {
      @for (itemGroup of page.content.items; track itemGroup; let itemGroupIndex = $index) {
        <cdk-accordion-item
          [expanded]="pageIndex === 0 && itemGroupIndex === 0"
          #accordionItem="cdkAccordionItem"
          class="item"
          role="button"
          tabindex="0"
          [attr.id]="'header-' + pageIndex + '-' + itemGroupIndex"
          [attr.aria-expanded]="accordionItem.expanded"
          [attr.aria-controls]="'body-' + itemGroupIndex"
        >
          <div class="header pb-0">
            <a
              (click)="accordionItem.open()"
              [routerLink]="['research', page.id, itemGroup.id]"
              routerLinkActive="active"
            >
              {{ getText(itemGroup.name) }}</a
            >
            <span class="item-description pointer" (click)="accordionItem.toggle()">
              <div class="arrow" [ngClass]="{ closed: accordionItem.expanded }"></div>
            </span>
          </div>
          <div
            class="item-body"
            role="region"
            [style.display]="accordionItem.expanded ? '' : 'none'"
            [attr.id]="'body-' + pageIndex + '-' + itemGroupIndex"
            [attr.aria-labelledby]="'header-' + pageIndex + '-' + itemGroupIndex"
          >
            <cdk-accordion [multi]="true" class="nested-accordion">
              @for (item of itemGroup.items; track item; let itemPageIndex = $index) {
                @if (item.kind === 'itempage') {
                  <cdk-accordion-item
                    [expanded]="item.id === (surveyResearchItemPageId$ | async) && itemGroupIndex === 0"
                    #accordionItem="cdkAccordionItem"
                    class="item"
                    role="button"
                    tabindex="0"
                    [attr.id]="'header-' + itemPageIndex"
                    [attr.aria-expanded]="accordionItem.expanded"
                    [attr.aria-controls]="'body-' + itemPageIndex"
                  >
                    <div class="header pl-2">
                      <a
                        (click)="accordionItem.open()"
                        [routerLink]="['research', page.id, itemGroup.id, item.id]"
                        routerLinkActive="active"
                        class="pointer"
                      >
                        {{ item.name | getTranslation: logEmptyTitle }}
                      </a>
                      <span (click)="accordionItem.toggle()" class="item-description pointer">
                        <div class="arrow" [ngClass]="{ closed: accordionItem.expanded }"></div>
                      </span>
                    </div>
                    <div
                      class="item-body"
                      role="region"
                      [style.display]="accordionItem.expanded ? '' : 'none'"
                      [attr.id]="'body-' + itemPageIndex"
                      [attr.aria-labelledby]="'header-' + itemPageIndex"
                    >
                      <ul>
                        @for (itemPageEl of item.items | filterCallback: isSection; track itemPageEl; let i = $index) {
                          <li>
                            <a
                              [routerLink]="['research', page.id, itemGroup.id, item.id]"
                              [fragment]="'section-' + (i + 1)"
                              >{{ getTitleOfSection(itemPageEl) }}</a
                            >
                          </li>
                        }
                      </ul>
                    </div>
                  </cdk-accordion-item>
                }
              }
            </cdk-accordion>
          </div>
        </cdk-accordion-item>
      }
    }
  }
</cdk-accordion>
<lib-lang-droplist class="lang-switcher"></lib-lang-droplist>
